import { Redirect } from 'expo-router';

import { NewMemberAccount } from '../../../auth/components/new-member/NewMemberAccount';
import { FRUITFUL_ENV } from '../../../config/config';

export default function NewMemberAccountPage() {
    return FRUITFUL_ENV === 'production' ? (
        <Redirect href="/sign-up/get-started" />
    ) : (
        <NewMemberAccount />
    );
}
